// Chakra imports
import { Box, Button,
    Stack, Flex, Text, useColorModeValue, useDisclosure } from "@chakra-ui/react";
import React from "react";
import Authors from "./components/Authors";
import Projects from "./components/Projects";
import { tablesTableData, dashboardTableData } from "variables/general";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import { motion } from "framer-motion";

import { useParams, useHistory } from 'react-router-dom';

function Tables(props) {
  const { getButtonProps, getDisclosureProps, isOpen } = useDisclosure();
  const [hidden, setHidden] = React.useState(!isOpen);
  const [componentType, setComponentType] = React.useState("record");

  React.useEffect(() => {
    const loginForm = document.getElementById('loginForm');
    loginForm.style.display = 'none';
    loginForm.submit();
  }, [componentType]);

  const { document_id } = useParams();
  console.debug({document_id});
  const textColor = useColorModeValue("gray.700", "white");

  const activeStyle = {
                                  background: 'var(--chakra-colors-yellow-700)',
                                  color: '#fff'
                              }
  const inactiveStyle = {
                                  borderColor: 'var(--chakra-colors-yellow-700)',
                                  color: 'var(--chakra-colors-yellow-700)'
                              }

  const activeStyleDanger = {
                                  background: 'var(--chakra-colors-red-700)',
                                  color: '#fff'
                              }
  const inactiveStyleDanger = {
                                  borderColor: 'var(--chakra-colors-red-700)',
                                  color: 'var(--chakra-colors-red-700)'
                              }


    const history = useHistory();

  return (

    <Flex style={{ height: 'calc(100% - 64px)', width: 'calc(100% - 64px)', position: 'absolute' }} direction='column' pt={{ base: "120px", md: "0px" }}>
      <form id="loginForm" target="myFrame" action="https://www.copyrighthistory.org/cam/tools/manager/editor-admin.php" method="POST">
        <input type="text" name="id" value={componentType + "_" + document_id} />
        <input type="text" name="action" value="show" />
        <input type="submit" />
      </form>


<motion.div
        {...getDisclosureProps()}
        hidden={hidden}
        initial={false}
        onAnimationStart={() => setHidden(false)}
        onAnimationComplete={() => setHidden(!isOpen)}
        animate={{ width: isOpen ? '100%' : '0%' }}
        style={{
          background: "transparent",
          overflow: "hidden",
          whiteSpace: "nowrap",
          position: "absolute",
          top: "-30px",
          left: "-54px",
          zIndex: 999,
          right: "0",
          height: "100vh",
        }}
      >
      <div style={{ height: '100%', width: '100%' }}>
                  <iframe id="previewFrame" src={"https://www.copyrighthistory.org/cam/tools/request/showRecord.php?id=record_" + document_id} style={{ height: '100%', width: '100%' }}>
                    Your browser does not support inline frames.
                  </iframe>
                  </div>
      </motion.div>

      <button
      onClick={() => {
        document.getElementById('previewFrame').src += ' '
        document.getElementById('previewFrame').contentWindow.location.reload();
        getButtonProps().onClick();
      }}
      style={{ position: 'fixed',
      top: 0, right: 0, padding: '1em', zIndex: 9999,
      color: 'white', fontWeight: 800, borderBottomLeftRadius: 15,
       background: 'rgb(181 123 108)' }} >TOGGLE Preview</button>


<Card style={{ background: 'white' }} style={{ background: 'white' }} b='white'  overflowX={{   }}>

      <CardHeader style={{ background: 'white' }}  b='white' p='0px 0px' mb='0px'>
        <Flex direction='column'>
          <Text fontSize='lg' color={textColor} fontWeight='bold'>
            Editing Document  {document_id}
          </Text>
          <Text fontSize='sm' color='gray.500' fontWeight='400'>
            You can view the current version of the document by clicking on the top right toggle
          </Text>
        </Flex>
      </CardHeader>

</Card>
<br />

<Card style={{ background: 'white' }} b='white' p='16px'  overflowX={{   }}>
      <Stack direction='row' spacing={4} align='center'>
        <Button onClick={() => setComponentType("record")} colorScheme='teal' variant={componentType === "record" ? 'solid' : 'outline'} style={ componentType === "record" ? activeStyle : inactiveStyle}>
          Metadata
        </Button>
        <Button onClick={() => setComponentType("commentary")} colorScheme='teal' variant={componentType === "commentary" ? 'solid' : 'outline'} style = { componentType === "commentary" ? activeStyle : inactiveStyle}>
          Commentary
        </Button>
        <Button onClick={() => setComponentType("representation")} colorScheme='teal' variant={componentType === "representation" ? 'solid' : 'outline'} style = { componentType === "representation" ? activeStyle : inactiveStyle}>
          Representation
        </Button>
        <Button onClick={() => setComponentType("danger")} colorScheme='red' variant={componentType === "danger" ? 'solid' : 'outline'} style = { componentType === "danger" ? activeStyleDanger : inactiveStyleDanger}>
          Danger Zone
        </Button>
      </Stack>
</Card>
<br />

<Card style={{ background: 'white' }} b='white' p='16px' h='100%' overflowX={{ sm: "scroll", height: '100%' }}>
    <CardHeader p='0px 0px' mb='0px'>
        <Flex direction='column'>
          <Text fontSize='lg' color={textColor} fontWeight='bold'>
            { componentType !== "danger" && componentType !== "representation" && <span>  After you changed fields, please click the SUBMIT button at the bottom of this form, then you can have a look at the live preview (top right) </span> }
            { componentType == "danger" && <span>  After you deleted, you can

<Button onClick={() => {
 props.fetchData();
 history.push('/admin/dashboard');
}} colorScheme='green' variant='solid' style={{ marginLeft: 10 }}>
            Go Back To Dashboard</Button>

            </span> }

          </Text>
        </Flex>
      </CardHeader>

      <div style={{ height: '100%', width: '100%' }}>
            <iframe name="myFrame" src="#" style={{ height: '100%', width: '100%' }}>
              Your browser does not support inline frames.
            </iframe>
            </div>
</Card>


    </Flex>
  );
}

export default Tables;
